import * as tslib_1 from "tslib";
import { observable, action } from 'mobx';
import { loading, Loadable } from '../utils/loading';
import TaskApi from '../services/TaskApi';
import NfcTaskFilter from '../pages/nfctask/NfcTaskFilter';
import TaskFilter from '../models/TaskFilter';
var NfcTaskStore = /** @class */ (function (_super) {
    tslib_1.__extends(NfcTaskStore, _super);
    function NfcTaskStore(userStore) {
        var _this = _super.call(this) || this;
        _this.userStore = userStore;
        _this.sprintIndex = 0;
        window.addEventListener('beforeunload', function () { return _this.clear(); });
        _this.filter = new NfcTaskFilter(_this.userStore);
        _this.taskFilter = new TaskFilter(_this.userStore);
        _this.setTitle("Válasszon projektet!");
        return _this;
    }
    NfcTaskStore.prototype.initialize = function () {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, TaskApi.getTaskStatuses()];
                    case 1:
                        _a.statuses = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NfcTaskStore.prototype.loadNfcTasks = function (userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, TaskApi.getNfcTasks(userId, this.sprintIndex)];
                    case 1:
                        _a.nfcTasks = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NfcTaskStore.prototype.finishTask = function (updated) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tmpArr, _i, _a, i, tmp;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updated.statusId = 5;
                        updated.percentage = 95;
                        tmpArr = [];
                        for (_i = 0, _a = this.nfcTasks; _i < _a.length; _i++) {
                            i = _a[_i];
                            tmp = i;
                            tmp.tasks = tmp.tasks.filter(function (x) { return x.id !== updated.id; });
                            tmpArr.push(tmp);
                        }
                        this.nfcTasks = tmpArr.filter(function (x) { return x.tasks.length > 0; });
                        this.selectedTask = null;
                        this.setTitle("Válasszon projektet!");
                        return [4 /*yield*/, TaskApi.updateNfcTask(updated)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NfcTaskStore.prototype.updateTask = function (updated) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tmpArr, _i, _a, i, tmp;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        tmpArr = [];
                        for (_i = 0, _a = this.nfcTasks; _i < _a.length; _i++) {
                            i = _a[_i];
                            tmp = i;
                            tmp.tasks = tmp.tasks.map(function (x) { return x.id === updated.id ? updated : x; });
                            tmpArr.push(tmp);
                        }
                        this.nfcTasks = tmpArr.filter(function (x) { return x.tasks.length > 0; });
                        return [4 /*yield*/, TaskApi.updateNfcTask(updated)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NfcTaskStore.prototype.taskAction = function (item) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var updated, tmpArr, _i, _a, i, tmp;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, TaskApi.taskAction(item)];
                    case 1:
                        _b.sent();
                        updated = this.getRunningTask();
                        updated.workerStatus = item.isPause ? 4 : 2;
                        tmpArr = [];
                        for (_i = 0, _a = this.nfcTasks; _i < _a.length; _i++) {
                            i = _a[_i];
                            tmp = i;
                            tmp.tasks = tmp.tasks.map(function (x) { return x.id === updated.id ? updated : x; });
                            tmpArr.push(tmp);
                        }
                        this.nfcTasks = tmpArr.filter(function (x) { return x.tasks.length > 0; });
                        return [2 /*return*/];
                }
            });
        });
    };
    NfcTaskStore.prototype.setSelectedTask = function (projectId) {
        this.selectedTask = this.nfcTasks.find(function (x) { return x.projectId === projectId; });
        this.setTitle("Válasszon feladatot!");
    };
    NfcTaskStore.prototype.getNfcTask = function () {
        return this.filter.applyOn(this.nfcTasks);
    };
    NfcTaskStore.prototype.getRunningTask = function () {
        var tasks = [];
        var validTasks = this.getNfcTask();
        for (var _i = 0, validTasks_1 = validTasks; _i < validTasks_1.length; _i++) {
            var i = validTasks_1[_i];
            i.tasks.forEach(function (x) { return tasks.push(x); });
        }
        var runningTask = tasks.find(function (x) { return x.statusId === 4; });
        if (runningTask) {
            this.setTitle("Válasszon készültségi szintet!");
        }
        return runningTask;
    };
    NfcTaskStore.prototype.setTitle = function (temp) {
        this.title = temp;
    };
    NfcTaskStore.prototype.navigateBack = function () {
        var runningTask = this.getRunningTask();
        if (runningTask) {
            runningTask.statusId = 2;
            if (!this.selectedTask) {
                for (var _i = 0, _a = this.nfcTasks; _i < _a.length; _i++) {
                    var i = _a[_i];
                    if (i.tasks.find(function (x) { return x.id === runningTask.id; })) {
                        this.selectedTask = i;
                    }
                }
            }
            this.updateTask(runningTask);
            this.setTitle("Válasszon feladatot!");
        }
        else {
            this.selectedTask = null;
            this.setTitle("Válasszon projektet!");
        }
    };
    NfcTaskStore.prototype.getStatusByID = function (id) {
        if (this.statuses) {
            return this.statuses.find(function (x) { return x.id === id; });
        }
        return null;
    };
    NfcTaskStore.prototype.getSelectedTask = function () {
        if (this.selectedTask) {
            var validTasks = Object.assign({}, this.selectedTask);
            validTasks.tasks = this.taskFilter.applyOn(validTasks.tasks);
            return validTasks;
        }
        return this.selectedTask;
    };
    NfcTaskStore.prototype.clear = function () {
        this.sprintIndex = 0;
        this.nfcTasks = [];
    };
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "nfcTasks", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "sprintIndex", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "statuses", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "selectedTask", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "title", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "filter", void 0);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "taskFilter", void 0);
    tslib_1.__decorate([
        action,
        loading
    ], NfcTaskStore.prototype, "loadNfcTasks", null);
    tslib_1.__decorate([
        action
    ], NfcTaskStore.prototype, "finishTask", null);
    tslib_1.__decorate([
        action
    ], NfcTaskStore.prototype, "updateTask", null);
    tslib_1.__decorate([
        action
    ], NfcTaskStore.prototype, "taskAction", null);
    tslib_1.__decorate([
        observable
    ], NfcTaskStore.prototype, "getRunningTask", null);
    tslib_1.__decorate([
        action.bound
    ], NfcTaskStore.prototype, "setTitle", null);
    return NfcTaskStore;
}(Loadable));
export default NfcTaskStore;



//////////////////
// WEBPACK FOOTER
// ./src/store/NfcTaskStore.ts
// module id = 375
// module chunks = 0